import { head, last, get, omit } from 'lodash';
import moment from '~/_moment';
import { PressureActionTypes } from '~/actions/pressure';

const initialState = {
  date: moment().format('YYYY-MM-DD'),
  startTime: '00:00',
  endTime: moment().format('HH:mm'),
  data: null,
  isloading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PressureActionTypes.LOAD_PRESSURE:
      const code = get(action, 'code', false);
      if (code !== 200) {
        return {
          ...state,
          data: null,
          isloading: false,
        };
      }

      const startTime =
        action.pressure_data && action.pressure_data.length
          ? moment(get(head(action.pressure_data), ['time'])).format('HH:mm')
          : state.startTime;
      const endTime =
        action.pressure_data && action.pressure_data.length
          ? moment(get(last(action.pressure_data), ['time'])).format('HH:mm')
          : state.endTime;
      return {
        ...state,
        startTime,
        endTime,
        data: action.pressure_data.map((item) => omit(item, ['rain'])),
        isloading: false,
      };
    case PressureActionTypes.SET_DATE:
      return {
        ...state,
        date: action.dateFormated,
      };
    case PressureActionTypes.SET_START_TIME:
      return {
        ...state,
        startTime: action.timeFormated,
      };
    case PressureActionTypes.SET_END_TIME:
      return {
        ...state,
        endTime: action.timeFormated,
      };
    case PressureActionTypes.SET_FILTER_DATE_TIME:
      return {
        ...state,
        date: action.date ? action.date : initialState.date,
        startTime: action.startTime ? action.startTime : initialState.startTime,
        endTime: action.endTime ? action.endTime : initialState.endTime,
      };
    case PressureActionTypes.RESET_IS_LOADING:
      return {
        ...state,
        isloading: true,
        data: null,
      };
    case PressureActionTypes.RESET_PRESSURE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/pressure.js